import $ from 'jquery';
import ReactDOM from 'react-dom';
import React from 'react';
import { compact, sortBy } from 'lodash';

import loadData from '../../lib/bootstrapped_data';
import Area from '../../components/here_maps/layers/Area';
import HereMap from '../../components/here_maps/HereMap.jsx';
import { setupRecurrenceRulesFormButtons } from '../../lib/form_helpers';

const AdministrationAreas = {
  init() {
    setupRecurrenceRulesFormButtons();
    this.renderMaps();
  },

  teardown() {
    const mapEl = window.document.getElementById('js-map-container');
    if (mapEl) {
      ReactDOM.unmountComponentAtNode(mapEl);
    }

    $('form').off('click', '.js-remove-row');
    $('form').off('click', '.js-all-day');
    $('form').off('click', '.js-copy');
    $('form').off('click', '.js-add-row');
    $('form').off('click', '.js-add-row-for-fare-adapter-element');
    $('form').off('change', 'select[name*="[fare_adapter_configuration_elements_attributes]"][name*="[price_type]"]');
    $('form').off('change', 'select[name*="[fare_adapter_configuration_elements_attributes]"][name*="[discount_type]"]');
  },

  renderArea() {
    const areas = sortBy(compact(loadData('areas').data), "z_index");
    if (!areas && areas.length === 0) return null;

    return areas.map((area) => <Area key={`area-${area.id}`}
                                     area={area.area}
                                     color={area.color}
                                     opacity={area.opacity}
                                     weight={area.stroke_weight}
                                     fillColor={area.fill_color}
                                     fillOpacity={area.fill_opacity} />);
  },
  renderMaps() {
    const mapEl = $('#js-map-container');
    if (!mapEl.length) return;

    ReactDOM.render(
        <HereMap noTraffic boundingBox={loadData('bbox')}>
          {this.renderArea()}
        </HereMap>,
        mapEl.get(0)
    );
  }
}

export default AdministrationAreas;
